import { render, staticRenderFns } from "./EditExchangeTransaction.vue?vue&type=template&id=31452ac2&"
import script from "./EditExchangeTransaction.vue?vue&type=script&lang=js&"
export * from "./EditExchangeTransaction.vue?vue&type=script&lang=js&"
import style0 from "./EditExchangeTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports